// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { color } from "@steiner/XDL/Utilities";
import { TransitionStatus } from "react-transition-group/Transition";
import styled, { css, ThemeProps } from "styled-components";

const HorizontalScrollIndicator = styled.span<
    { direction: "left" | "right"; transitionState: TransitionStatus } & ThemeProps<BaseTheme>
>`
    position: absolute;
    width: 38px;
    height: 100%;
    top: 0;
    z-index: 1;
    color: ${getColor("common.white")};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all ease-in-out ${getProp("theme.transition.duration.regular")}ms;

    ${({ transitionState }) => {
        switch (transitionState) {
            case "entering":
                return "opacity: 0;";
            case "entered":
                return "opacity: 1;";
            case "exiting":
            case "exited":
                return "opacity: 0;";
            default:
                return "";
        }
    }}
    ${({ direction }) => {
        if (direction === "left") {
            return css`
                left: 0;
                background: linear-gradient(270deg, ${color("common.white", 0)} 0%, ${color("common.white", 1)} 100%);
            `;
        }
        if (direction === "right") {
            return css`
                right: 0;
                background: linear-gradient(270deg, ${color("common.white", 1)} 0%, ${color("common.white", 0)} 100%);
            `;
        }
    }}
`;

export default HorizontalScrollIndicator;
